module.exports = __webpack_public_path__ + "static/m-cc27dc466ff8dbe39864efeed09e52d4.jpg";